module.exports = __webpack_public_path__ + "img/avatar.8a5f0958.svg";